import { Component } from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatListModule} from '@angular/material/list';

@Component({
  imports: [
    MatCardModule,
    MatListModule
  ],
  selector: 'app-release-notes',
  standalone: true,
  styleUrls: ['./release-notes.component.scss'],
  templateUrl: './release-notes.component.html'
})
export class ReleaseNotesComponent {
  releaseDates = {
    '3.4.4': new Date('2025-12-03T10:19:00+0100'),
    '3.4.3': new Date('2025-11-12T22:43:31+0100'),
    '3.4.2': new Date('2025-11-05T10:00:00+0100'),
    '3.4.1': new Date('2025-10-29T09:44:38+0100'),
    '3.4.0': new Date('2025-10-28T19:26:43+0100'),
    '3.3.5': new Date('2025-10-28T18:18:32+0100'),
    '3.3.4': new Date('2025-10-22T19:51:03+0200'),
    '3.3.3': new Date('2025-10-20T14:23:21+0200'),
    '3.3.2': new Date('2025-07-06T19:48:06+0200'),
    '3.2.1': new Date('2024-05-27T19:30:47+0200'),
    '3.2.0': new Date('2024-05-20T17:53:59+0200')
  };

  formatDate(date: Date): string {
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }
}

